import type { EstadoCuota } from '@doc/shared';
import { tamano } from '../lib/formato.js';

/**
 * Barra de uso de una cuota.
 *
 * El color no es decoración: es el único aviso que ve alguien que no entra a
 * la pantalla de cuotas. Verde mientras sobra, ámbar desde el 80 % —el umbral
 * que pidió el negocio— y rojo cuando ya no cabe nada más.
 */
export function BarraCuota({
  usadoBytes,
  cuotaBytes,
  estado,
  porcentaje,
  compacta,
}: {
  usadoBytes: number;
  cuotaBytes: number | null;
  estado: EstadoCuota;
  porcentaje: number | null;
  compacta?: boolean;
}) {
  if (cuotaBytes === null) {
    return (
      <div className="cuota">
        <div className={`cuota__barra${compacta ? ' compacta' : ''}`}>
          <div className="cuota__relleno sin-cuota" style={{ width: '100%' }} />
        </div>
        <div className="cuota__texto">
          <span>{tamano(usadoBytes)} usados</span>
          <span className="dim">sin límite</span>
        </div>
      </div>
    );
  }

  // La barra se corta en 100 aunque el uso lo supere: una barra al 130 % se
  // sale de la caja y no dice nada que el número no diga mejor.
  const ancho = Math.min(100, porcentaje ?? 0);

  return (
    <div className="cuota">
      <div className={`cuota__barra${compacta ? ' compacta' : ''}`}>
        <div className={`cuota__relleno ${estado.toLowerCase()}`} style={{ width: `${ancho}%` }} />
      </div>
      <div className="cuota__texto">
        <span>
          <strong>{tamano(usadoBytes)}</strong> de {tamano(cuotaBytes)}
        </span>
        <span className={estado === 'OK' ? 'dim' : estado === 'ALERTA' ? 'aviso-ambar' : 'aviso-rojo'}>
          {porcentaje}%
        </span>
      </div>
    </div>
  );
}
